// extracted by mini-css-extract-plugin
export default {"action":"BusinessesTable_action__ATzQi"};